import React from 'react';
import styles from './Footer.module.scss';
import Element, { CommonProps } from '../Element/Element';
import BodyText from '../Typography/BodyText/BodyText';
import MarginSpace from '../MarginSpace/MarginSpace';
import Link, { LinkProps } from '../Link/Link';
import Flex from '../Flex/Flex';

type FooterProps = {
  /** List of links displayed in footer */
  links?: (LinkProps & {
    title: string;
  })[];
  /** Text next to copyright label */
  bottomText?: string;
  /** Overrides the copyright year in Footer. Is supposed to be used ONLY in tests, in order to prevent tests from changing every new year */
  copyrightYear?: number;
} & CommonProps<'div'>;

const Footer: React.FunctionComponent<FooterProps> = ({
  links,
  bottomText,
  className,
  copyrightYear = new Date().getFullYear(),
  ...props
}) => {
  const resolvePadding = links
    ? { top: 'xlg' as const, bottom: 'lg' as const }
    : { bottom: 'md' as const };

  return (
    <Element
      padding={resolvePadding}
      className={className}
      tagName="footer"
      backgroundColor="purple700"
      {...props}
    >
      <MarginSpace>
        {links && (
          <Flex
            centeredHorizontally
            wrapContent
            className={styles.footer__links}
          >
            {links.map(
              ({ title, onClick, to, openInNewWindow, ...linkProps }, key) => (
                <Link
                  key={key}
                  onClick={onClick}
                  to={to}
                  openInNewWindow={openInNewWindow}
                  {...linkProps}
                >
                  <BodyText
                    block
                    tagName="p"
                    color="white"
                    className={styles.footer__link}
                    padding={{ horizontal: 'lg' }}
                  >
                    {title}
                  </BodyText>
                </Link>
              )
            )}
          </Flex>
        )}
        <Flex
          centeredHorizontally
          padding={{ vertical: 'md' }}
          className={styles.footer__bottom}
        >
          {bottomText && <BodyText tagName="span">{bottomText}</BodyText>}
          <BodyText tagName="span" className={styles.footer__copyright}>
            © Telia Company {copyrightYear}
          </BodyText>
        </Flex>
      </MarginSpace>
    </Element>
  );
};

export default Footer;
